// The BO's design tokens, direction « Graff soigné » (docs/design/bo-maquette-A-graff-soigne.html),
// taken from the app's Graff charter (yourz-mobile/constants/colors.ts). Single source for the
// Material UI theme, the legacy theme (theme.js) and the DevExtreme stylesheet (public/graff-dx.css,
// plain CSS: its values are copied there by hand).
export const graff = {
  color: {
    wall: '#ECE8E0',
    surface: '#FFFFFF',
    sunken: '#F4F1EA',
    ink: '#151515',
    muted: '#57524A',
    subtle: '#6E6960',
    border: 'rgba(21,21,21,.10)',
    borderStrong: 'rgba(21,21,21,.22)',
    hover: 'rgba(21,21,21,.05)',
    pink: '#FF2E88',
    pinkHover: '#FF3F93',
    pinkDeep: '#E0146E',
    pinkSoft: '#FFE3EF',
    cyan: '#1FD1F9',
    cyanInk: '#0A6E86',
    cyanSoft: '#DDF7FE',
    yellow: '#FFE14D',
    danger: '#D7263D',
    asphalt: '#2B2B2B',
  },
  radius: { sm: 11, md: 16, lg: 22 },
  // Soft, warm shadows (the mockup's --sh-1, --sh-2, --sh-3).
  shadow: {
    sm: '0 1px 2px rgba(40,30,10,.05), 0 2px 6px rgba(40,30,10,.04)',
    md: '0 1px 2px rgba(40,30,10,.05), 0 8px 24px -6px rgba(40,30,10,.10), 0 20px 48px -18px rgba(40,30,10,.12)',
    lg: '0 2px 4px rgba(40,30,10,.06), 0 18px 40px -10px rgba(40,30,10,.20)',
  },
  // Focus ring of fields and search boxes.
  focusRing: '0 0 0 4px rgba(31,209,249,.25)',
  // The app's signature, kept for the main action only: ink outline and a solid "drip" shadow.
  action: {
    border: '2px solid #151515',
    shadow: '0 4px 0 #151515',
    shadowHover: '0 5px 0 #151515',
    shadowPressed: '0 1px 0 #151515',
  },
  font: {
    body: 'Archivo, system-ui, -apple-system, "Segoe UI", sans-serif',
    display: '"Londrina Solid", Archivo, sans-serif',
  },
};
